<template>
  <v-card title="公告发布">
    <div class="grid-demo">
      <v-form slot="form">
        <v-row :gutter="24">
          <v-col class="gutter-row" span="8">
            <div style="text-align: left">
              <v-form-item>
                <v-button type="success" icon="plus" @click="add('')"
                  ><span>添加</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <br />
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :data="tableData"
    >
      <!--自定义插槽 cz-->
      <template v-slot:cz="{ row }">
        <span>
          <span>
            <a class="link" @click="add(row)" title="修改">
              <v-icon type="edit"></v-icon>
            </a>
            &nbsp;&nbsp;
            <v-popconfirm title="确定删除吗?" @confirm="del(row)" @cancel="cancel" placement="bottom">
              <a class="link" title="删除">
                <v-icon type="delete"></v-icon>
              </a>
            </v-popconfirm>
          </span>
        </span>
      </template>
      <template v-slot:empty>
        <span style="color: red;">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
  </v-card>
</template>
<script>
let options = {
  id: ""
};
export default {
  data() {
    return {
      options,
      checked: true,
      tableData: [],
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: 408,
        headerAlign: "center",
        checkboxConfig: {
          labelField: "id",
          highlight: true,
          range: true
        },
        editConfig: {
          trigger: "", //click可以编辑表格
          mode: "row",
          showStatus: true
        },
        columns: [
          {
            type: "seq",
            title: "序号",
            width: 70,
            align: "center"
          },
          {
            field: "bt",
            title: "标题",
            align: "center"
          },
          {
            field: "nr",
            title: "内容",
            align: "center"
          },
          {
            field: "fbsj",
            title: "发布时间",
            align: "center",
            formatter:this.formatDate
          },
          {
            field: "jzrq",
            title: "截止日期",
            align: "center",
            formatter:this.formatDate
          },
          {
            field: "yxbz",
            title: "状态",
            align: "center",
            slots: {
              default: ({ row, column }) => {
                let yxbz = row.yxbz==1?"启用":"禁用"
                return [                  
                    <span>{yxbz}</span>
                ];
              }
            }
          },
          {
            field: "cz",
            title: "操作",
            align: "center",
            slots: {
              // 对应自定义插槽的名称
              default: "cz"
            }
          }
        ]
      }
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.$axios
        .get(
          "api/system/ggfb/get-ggfb-list"
        )
        .then(res => {
          this.tableData = res.data;
        });
    },
    add: function (row) {
      let id = row == "" ? "" : row.gg_id;
      let title = row == "" ? "添加公告" : "修改公告";
      xadmin.open(title, "/ggfbadd?id=" + id, "600", "500");
    },
    del: function (row) {
      this.$axios
        .get("api/system/ggfb/del-ggfb-list?id=" + row.gg_id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message["success"](res.data.message);
            this.findList();
          } else {
            this.$message["error"](res.data.message);
          }
        });
    },
    formatDate ({ cellValue }) {
      return cellValue.replace("T","  ");
	},
    cancel: function () {
      this.$message.info("取消删除");
    },
  }
};

</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/jcsj/ggfb.vue